import { render } from "./NavItems.vue?vue&type=template&id=3826e218&scoped=true"
import script from "./NavItems.vue?vue&type=script&lang=js"
export * from "./NavItems.vue?vue&type=script&lang=js"

import "./NavItems.vue?vue&type=style&index=0&id=3826e218&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3826e218"

export default script